import hoveredElementWatcher from './hovered-element-watcher';

export default {
  hoveredElementWatcher,
};
